export default "__VITE_ASSET__4dd66a40__"